import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntite, EntiteStatique } from '.';
import { Horaire } from './horaire.entity';
import { TableauPlageHoraire } from './tableau-plage-horaire.entity';

@EntiteStatique()
@Entity('plage_horaire')
export class PlageHoraire implements BaseEntite {
    static key = 'plage-horaire';

    constructor() {
        this.ordre = 0;
        this.pour_quoi = '';
    }

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: true })
    name: string;

    @Column({ nullable: true })
    fk_id_horaire: number;

    @ManyToOne(() => Horaire)
    @JoinColumn({ name: 'fk_id_horaire', referencedColumnName: 'id' })
    horaire: Horaire;

    @Column({ nullable: true })
    fk_id_tableau_plage_horaire: number;

    @ManyToOne(() => TableauPlageHoraire)
    @JoinColumn({ name: 'fk_id_tableau_plage_horaire', referencedColumnName: 'id' })
    tableauPlageHoraire: TableauPlageHoraire;

    @Column({ type: 'date', nullable: true })
    date: string;

    @Column({ type: 'text', nullable: true })
    description: string;

    @Column({ type: 'time', nullable: true })
    debut: string;

    @Column({ type: 'time', nullable: true })
    fin: string;

    @Column({ type: 'text', nullable: true })
    notes: string;

    @Column({ nullable: false })
    pour_quoi: string; // csv qui peut contenir "client,autobus1,autobus2,fournisseur1[etc.]" autobus1 et autobus2, 1 et 2 sont les id des activités.

    @Column()
    ordre: number;
}
